import React from 'react';
import './Samples.css';
import { SAMPLE_ADS } from '../data/sampleAdsData';
import SEO from '../components/SEO';

function Samples() {
  return (
    <div className="samples-page">
      <SEO 
        title="Sample Newspaper Ads - Classifieds Format"
        description="View sample newspaper advertisements for Matrimonial, Property, Recruitment, Name Change, and more. See how your ad will look in the newspaper."
        keywords="sample newspaper ads, matrimonial ad sample, property ad format, name change ad sample, classified ad examples"
        url="/samples"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Ad Samples', url: '/samples' }
        ]}
      />
      
      <section className="samples-hero">
        <div className="container">
          <h1>Sample Newspaper Ads</h1>
          <p>Browse through our collection of sample ads to help you draft your perfect advertisement.</p>
        </div>
      </section>

      <section className="newspaper-container">
        <div className="newspaper-header">
          <div className="newspaper-name">THE DAILY CLASSIFIEDS</div>
          <div className="newspaper-meta">
            <span>VOL. XCVIII NO. 123</span>
            <span>INDIA'S LEADING NEWSPAPER</span>
            <span>PAGES 12</span>
          </div>
        </div>

        <div className="content-grid-layout">
          {SAMPLE_ADS.map((categoryData, index) => (
            <div key={index} className="content-column-item">
              <h3 className="category-header">{categoryData.category}</h3>
              <div className="content-list-wrapper">
                {categoryData.ads.map((ad, adIndex) => (
                  <div key={adIndex} className="content-item-box">
                    <h4>{ad.title}</h4>
                    <p>{ad.content}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Samples;
